webpackJsonp([199180123508537],{

/***/ 1241:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _formik = __webpack_require__(10);
	
	var _yup = __webpack_require__(13);
	
	var Yup = _interopRequireWildcard(_yup);
	
	var _Alert = __webpack_require__(14);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _Input = __webpack_require__(9);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _RadioGroup = __webpack_require__(16);
	
	var _RadioGroup2 = _interopRequireDefault(_RadioGroup);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormProduct = function (_Component) {
	  _inherits(FormProduct, _Component);
	
	  function FormProduct(props) {
	    _classCallCheck(this, FormProduct);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      formState: null
	    };
	    return _this;
	  }
	
	  FormProduct.prototype.render = function render() {
	    var _this2 = this;
	
	    var formState = this.state.formState;
	    var _props = this.props,
	        classes = _props.classes,
	        className = _props.className;
	
	
	    var valid = function valid(current) {
	      return current.day() !== 0 && current.day() !== 6;
	    };
	
	    var renderDay = function renderDay(props, currentDate, selectedDate) {
	      if (currentDate.month() == (0, _moment2.default)().month()) {
	        if (currentDate.date() < (0, _moment2.default)().date()) {
	          if (props.className == "rdtDay") {
	            props.className = "rdtDay rdtDisabled";
	          }
	        }
	      }
	      if (currentDate.month() < (0, _moment2.default)().month()) {
	        props.className = "rdtDay rdtDisabled";
	      }
	
	      return _react2.default.createElement(
	        "td",
	        props,
	        currentDate.date()
	      );
	    };
	
	    if (formState === "success") {
	      if (typeof window !== "undefined") {
	        window.location.href = "/freetrial_thankyou";
	      }
	      return _react2.default.createElement(
	        "div",
	        {
	          style: {
	            maxWidth: "600px",
	            textAlign: "center",
	            margin: "24px auto"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _Typography2.default,
	            {
	              type: "heading3",
	              gutterBottom: true,
	              style: { color: "#f15623" }
	            },
	            "Welcome to Elm Street!"
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { type: "heading4", gutterTop: true, style: { fontSize: "18px" } },
	            "A member of our Success Team will reach out shortly to finish activating your FREE trial account."
	          ),
	          _react2.default.createElement("hr", null),
	          _react2.default.createElement(
	            _Typography2.default,
	            { type: "heading5", gutterTop: true, style: { fontSize: "18px" } },
	            "TRAINING SERIES IN REAL ESTATE"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Elm Street Academy offers empowering, high-energy educational webinars on a variety of topics such as:"
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Social Media Marketing"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Online Lead Generation"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "uilding Repeat & Referral Business"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Innovative Thought Leadership"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Technology Trends"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Business Planning"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "And...MORE!"
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "p",
	            null,
	            "FREE Registration. Great Educators. Actionable Content."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "https://elmstreet.com/events" },
	              "Browse Upcoming Events"
	            )
	          )
	        )
	      );
	    } else if (formState === "error") {
	      return _react2.default.createElement(
	        "div",
	        { style: { maxWidth: "400px", margin: "24px auto" } },
	        _react2.default.createElement(
	          _Alert2.default,
	          { color: "error" },
	          "An error occurred."
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: (0, _classnames2.default)(classes.root, className) },
	      _react2.default.createElement(_formik.Formik, {
	        initialValues: {
	          firstname: "",
	          lastname: "",
	          company: "",
	          email: "",
	          phone: "",
	          mls_number: "",
	          form: "form_freetrial",
	          list: this.props.listid,
	          meetingdate: "",
	          meetingtime: "",
	          role: "",
	          interests: "",
	          subject: this.props.subject,
	          webhook: this.props.webhook,
	          lead_source: this.props.leadsource
	        },
	        validationSchema: function validationSchema() {
	          return Yup.object().shape({
	            firstname: Yup.string().required("First name is required"),
	            lastname: Yup.string().required("Last name is required"),
	            company: Yup.string(),
	            email: Yup.string().email("Invalid email address").required("Email is required"),
	            phone: Yup.string().required("Phone is required"),
	            mls_number: Yup.string()
	          });
	        },
	        onSubmit: function onSubmit(values, _ref) {
	          var setSubmitting = _ref.setSubmitting;
	
	          //if (values.meetingdate != undefined) {
	          var meeting_request = "";
	          var notes = "Interests: ";
	          Object.keys(values).forEach(function (key, index) {
	            // key: the name of the object key
	            // index: the ordinal position of the key within the object
	            if (key == "meetingdate") {
	              if (typeof values.meetingdate.format === "function") {
	                meeting_request = values.meetingdate.format("YYYY-MM-DD") + "T" + values.meetingtime.replace(" (EDT)", "") + "-04:00";
	              }
	            }
	            if (key == "roleOther") {
	              if (values.roleOther.length > 0) {
	                values.role = values.roleOther;
	              }
	            }
	            if (key == "interestsOther") {
	              if (values.interestsOther.length > 0) {
	                //notes = values.interests.join(",");
	                notes = notes + "," + values.interestsOther;
	              }
	            }
	            if (key == "interests") {
	              if (values.interests.length > 0) {
	                notes = notes + "," + values.interests.join(",");
	              }
	            }
	            if (key == "demorequest") {
	              if (values.demorequest) {
	                notes = notes + ", Requesting 15 min demo";
	              }
	            }
	            if (key == "market1") {
	              if (values.market1) {
	                notes = notes + ", Markets: " + values.market1 + "," + values.market2 + "," + values.market3;
	              }
	            }
	          });
	
	          var body = _extends({}, values, {
	            notes: notes,
	            utm_campaign: window.utm_tags ? window.utm_tags.campaign : "",
	            utm_source: window.utm_tags ? window.utm_tags.source : "",
	            utm_medium: window.utm_tags ? window.utm_tags.medium : "",
	            utm_term: window.utm_tags ? window.utm_tags.term : "",
	            demo_request_date: meeting_request
	          });
	          return fetch("https://hooks.zapier.com/hooks/catch/4496703/3uy9gh0/", {
	            method: "POST",
	            body: JSON.stringify(body)
	          }).then(function (response) {
	            return response.json();
	          }).then(function (res) {
	            if (res.status === "success") {
	              _this2.setState({ formState: "success" });
	              dataLayer.push({ event: "form-success" });
	
	              if (window.fbq) {
	                window.fbq("track", "Lead");
	              }
	              if (window.gtag) {
	                window.gtag("event", "conversion", {
	                  send_to: "AW-980447970/2_aHCOnsjo8BEOLlwdMD"
	                });
	              }
	              if (window.ga) {
	                window.ga("send", "event", "form", "form_completed", "bright");
	              }
	            } else {
	              _this2.setState({ formState: "error" });
	            }
	          }).catch(function (err) {
	            _this2.setState({ formState: "error" });
	          });
	        },
	        render: function render(_ref2) {
	          var values = _ref2.values,
	              isSubmitting = _ref2.isSubmitting,
	              handleBlur = _ref2.handleBlur,
	              handleChange = _ref2.handleChange;
	          return _react2.default.createElement(
	            _formik.Form,
	            { noValidate: true },
	            _react2.default.createElement("div", { style: { marginBottom: "30px" } }),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  maxWidth: "600px",
	                  marginLeft: "auto",
	                  marginRight: "auto"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: classes.topRow },
	                _react2.default.createElement(_formik.Field, {
	                  id: "firstname",
	                  name: "firstname",
	                  label: "First Name",
	                  component: _Input2.default,
	                  className: classes.field
	                }),
	                _react2.default.createElement(_formik.Field, {
	                  id: "lastname",
	                  name: "lastname",
	                  label: "Last Name",
	                  component: _Input2.default,
	                  className: classes.field
	                })
	              ),
	              _react2.default.createElement(_formik.Field, {
	                id: "email",
	                name: "email",
	                label: "Email",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "phone",
	                name: "phone",
	                label: "Phone",
	                component: _Input2.default,
	                className: classes.field,
	                type: "tel"
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "company",
	                name: "company",
	                label: "Affiliation (optional)",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "mls_number",
	                name: "mls_number",
	                label: "MLS # (optional)",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    textAlign: "left",
	                    fontSize: "14px",
	                    lineHeight: "19px"
	                  }
	                },
	                _react2.default.createElement(_formik.Field, {
	                  id: "role",
	                  name: "role",
	                  label: "I am:",
	                  component: _RadioGroup2.default,
	                  display: "inline",
	                  items: [{
	                    label: "An Existing Client",
	                    value: "Existing Client"
	                  }, {
	                    label: "An Agent",
	                    value: "Agent"
	                  }, {
	                    label: "A Broker/Owner",
	                    value: "Broker/Owner"
	                  }, {
	                    label: "Other (please specify)",
	                    value: "Other"
	                  }],
	                  className: classes.field
	                }),
	                values.role === "Other" && _react2.default.createElement(_formik.Field, {
	                  id: "roleOther",
	                  name: "roleOther",
	                  label: "Other",
	                  component: _Input2.default,
	                  className: classes.field,
	                  autoFocus: true
	                })
	              ),
	              _this2.props.showMarkets && _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  { style: { width: "100%", textAlign: "center" } },
	                  "What are your top 3 markets of interest? (optional)"
	                ),
	                _react2.default.createElement(_formik.Field, {
	                  id: "market1",
	                  name: "market1",
	                  label: "City/State",
	                  component: _Input2.default,
	                  className: classes.field,
	                  onBlur: _this2.setFormVal
	                }),
	                _react2.default.createElement(_formik.Field, {
	                  id: "market2",
	                  name: "market2",
	                  label: "City/State",
	                  component: _Input2.default,
	                  className: classes.field,
	                  onBlur: _this2.setFormVal
	                }),
	                _react2.default.createElement(_formik.Field, {
	                  id: "market3",
	                  name: "market3",
	                  label: "City/State",
	                  component: _Input2.default,
	                  className: classes.field,
	                  onBlur: _this2.setFormVal
	                })
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "submit",
	                  className: classes.signUpBtn,
	                  disabled: isSubmitting
	                },
	                "Let's Get Started!"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  fontSize: "11px",
	                  lineHeight: "16px",
	                  paddingBottom: "35px"
	                }
	              },
	              "*NEW ACCOUNTS ONLY. SPECIAL PRICING DOES NOT INCLUDE ADDITIONAL LEAD GENERATION / PAY-PER-CLICK SERVICES.",
	              _react2.default.createElement("br", null),
	              "By submitting this form, you are requesting to be contacted by a member of the Elevate Sales Team at the details provided via text, email or call (may involve automated or pre-recorded means). You may revoke this consent through any reasonable means. Existing subscribers seeking support, please visit the",
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://support.tryelevate.com/s/ " },
	                "Elevate Help Center"
	              ),
	              "."
	            )
	          );
	        }
	      })
	    );
	  };
	
	  return FormProduct;
	}(_react.Component);
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _fullWidthVid;
	
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      maxWidth: "700px",
	      margin: "0 auto",
	      textAlign: "center"
	    },
	    link: {
	      color: "inherit"
	    },
	    field: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "50px",
	      fontWeight: "600",
	      textAlign: "left"
	    },
	    topRow: {
	      display: "flex",
	      flexDirection: "row",
	      justifyContent: "space-between",
	
	      "& > * + *": {
	        marginLeft: "12px"
	      }
	    },
	    headingSmall: {
	      fontSize: "20px",
	      textTransform: "uppercase",
	      fontWeight: "600",
	      color: "#777777",
	      textAlign: "center",
	      padding: "3px"
	    },
	    headingLarge: {
	      fontSize: "33px",
	      fontWeight: "700",
	      color: "#5bc0b8",
	      textAlign: "center",
	      padding: "3px",
	      lineHeight: "38px"
	    },
	    headingText: {
	      color: "#777777",
	      textAlign: "center",
	      padding: "3px",
	      lineHeight: "1.4em"
	    },
	    checkfield: {
	      width: "20px",
	      height: "20px",
	      position: "relative",
	      top: "4px",
	      marginLeft: "10px"
	    },
	    signUpBtn: {
	      width: "60%",
	      fontSize: "18px",
	      lineHeight: "26px",
	      fontWeight: "600",
	      color: "#FFF",
	      backgroundColor: "#5bc0b8",
	      borderRadius: "6px",
	      padding: "12px",
	      marginTop: "30px",
	      marginBottom: "30px",
	      textDecoration: "none"
	    },
	    selectfield: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "40px"
	    },
	    selectlabel: {
	      width: "100%",
	      color: "#888f96",
	      display: "flex",
	      fontSize: "14px",
	      alignItems: "center",
	      lineHeight: "18px",
	      fontWeight: "700",
	      marginBottom: "4px"
	    },
	
	    fullWidthVid: (_fullWidthVid = {
	      width: "100%",
	      marginLeft: "auto",
	      marginRight: "auto"
	    }, _fullWidthVid[theme.breakpoints[900]] = {
	      width: "75%"
	    }, _fullWidthVid)
	  };
	})(FormProduct);
	module.exports = exports["default"];

/***/ }),

/***/ 3031:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/av.15c92b58.png";

/***/ }),

/***/ 3166:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/newl.7f7af9cf.png";

/***/ }),

/***/ 1379:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/spcrmbg.07087a7b.jpg";

/***/ }),

/***/ 1380:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sprologo.e612e808.png";

/***/ }),

/***/ 1691:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _BgSectionExternal = __webpack_require__(33);
	
	var _BgSectionExternal2 = _interopRequireDefault(_BgSectionExternal);
	
	var _spcrmbg = __webpack_require__(1379);
	
	var _spcrmbg2 = _interopRequireDefault(_spcrmbg);
	
	var _fadebg = __webpack_require__(42);
	
	var _fadebg2 = _interopRequireDefault(_fadebg);
	
	var _sprologo = __webpack_require__(1380);
	
	var _sprologo2 = _interopRequireDefault(_sprologo);
	
	var _quote = __webpack_require__(51);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _sp = __webpack_require__(64);
	
	var _sp2 = _interopRequireDefault(_sp);
	
	var _newl = __webpack_require__(3166);
	
	var _newl2 = _interopRequireDefault(_newl);
	
	var _sp3 = __webpack_require__(92);
	
	var _sp4 = _interopRequireDefault(_sp3);
	
	var _av = __webpack_require__(3031);
	
	var _av2 = _interopRequireDefault(_av);
	
	var _glance = __webpack_require__(49);
	
	var _glance2 = _interopRequireDefault(_glance);
	
	var _glance3 = __webpack_require__(50);
	
	var _glance4 = _interopRequireDefault(_glance3);
	
	var _SEO = __webpack_require__(6);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _FormFreetrial = __webpack_require__(1241);
	
	var _FormFreetrial2 = _interopRequireDefault(_FormFreetrial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Freetrial = function Freetrial(_ref) {
	  var _ref2;
	
	  var children = _ref.children,
	      classes = _ref.classes,
	      data = _ref.data,
	      tags = _ref.tags;
	
	  var postNode = {
	    title: "Elevate Free Trial - " + _siteConfig2.default.siteTitle
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.root },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        "Elevate Free Trial - " + _siteConfig2.default.siteTitle
	      )
	    ),
	    _react2.default.createElement(_SEO2.default, { postNode: postNode, pagePath: "Freetrial", customTitle: true }),
	    _react2.default.createElement(
	      "div",
	      { style: { backgroundImage: "url(" + _spcrmbg2.default + ")", backgroundSize: "cover", backgroundPosition: "centerTop" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.top, style: (_ref2 = { paddingBottom: "30px", paddingRight: "35px", paddingLeft: "35px", paddingTop: "95px" }, _ref2["paddingBottom"] = "95px", _ref2) },
	          _react2.default.createElement(
	            "div",
	            { className: classes.centerHeading },
	            _react2.default.createElement(
	              "div",
	              { className: classes.heading, style: { color: "#ffffff" } },
	              _react2.default.createElement(
	                "span",
	                { style: { color: "#f9ea6c" } },
	                "CYBER MONDAY"
	              ),
	              _react2.default.createElement("br", null),
	              "GET THE ELEVATE CRM - FIRST MONTH FREE",
	              _react2.default.createElement(
	                "span",
	                { style: { fontSize: "19px" } },
	                _react2.default.createElement(
	                  "sup",
	                  null,
	                  "*"
	                )
	              ),
	              _react2.default.createElement("br", null),
	              "ANY LEVEL. ANY PACKAGE."
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext, style: { color: "#f7f7f7", fontSize: "18px" } },
	              "Voted the #1 Social Media CRM for Real Estate Agents in 2022, by TheClose.com.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { style: { textAlign: "center", paddingBottom: "10px" } },
	                _react2.default.createElement(
	                  "a",
	                  { href: "#demo", className: classes.buttonLink },
	                  "Create Your Account Today!"
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingTop: "50px", paddingBottom: "50px", backgroundColor: "#333666" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.top },
	          _react2.default.createElement(
	            "div",
	            { className: classes.column2, style: { padding: "30px", textAlign: "center" } },
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center" }, className: classes.videoEmbed },
	              _react2.default.createElement("iframe", { className: classes.videoContainer, src: "https://www.youtube.com/embed/WMqvFA708ss",
	                frameborder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowfullscreen: true })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column2, style: { padding: "30px", textAlign: "center" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.Heading2 },
	              _react2.default.createElement(
	                "span",
	                { style: { color: "#f9ea6c" } },
	                "CYBER MONDAY SPECIAL"
	              ),
	              _react2.default.createElement("br", null),
	              "FIRST MONTH IS FREE",
	              _react2.default.createElement(
	                "span",
	                { style: { fontSize: "19px" } },
	                _react2.default.createElement(
	                  "sup",
	                  null,
	                  "*"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext, style: { color: "#f7f7f7" } },
	              "Elevate's CRM offers busy real estate professionals a comprehensive, all-in-one lead generation & nurturing solution that is UNPARALLELED in the space."
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center", paddingTop: "15px" } },
	              _react2.default.createElement(
	                "a",
	                { href: "#demo", className: classes.buttonLink },
	                "Create Your Account!"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingTop: "58px" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { textAlign: "center", paddingRight: "35px", paddingLeft: "35px", paddingBottom: "35px" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.Heading2 },
	            "The Elevate CRM Includes..."
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.subtext },
	            "Automate your lead generation & social media marketing so you can focus on what matters the most...",
	            _react2.default.createElement("br", null),
	            "growing your sphere & selling more homes, faster..."
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { backgroundImage: "url(" + _fadebg2.default + ")", backgroundSize: "cover", backgroundPosition: "centerBottom" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.top, style: { textAlign: "center" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.column3, style: { textAlign: "center", paddingTop: "20px" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Customized social branding on Facebook, Twitter, LinkedIn & YouTube"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center" } },
	              _react2.default.createElement("img", { src: _sp2.default, width: "100%", style: { paddingTop: "25px", maxWidth: "320px" } })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column3, style: { textAlign: "center", paddingTop: "20px" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Lead Generation & Prospecting,",
	              _react2.default.createElement("br", null),
	              "with leads provided monthly"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center" } },
	              _react2.default.createElement("img", { src: _newl2.default, width: "100%", style: { paddingTop: "25px", maxWidth: "320px" } })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column3, style: { textAlign: "center", paddingTop: "20px" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Automated posts of new listings",
	              _react2.default.createElement("br", null),
	              "& listing updates"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center" } },
	              _react2.default.createElement("img", { src: _sp4.default, width: "100%", style: { paddingTop: "25px", maxWidth: "320px" } })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingTop: "40px", backgroundImage: "url(" + _fadebg2.default + ")", backgroundSize: "cover", backgroundPosition: "centerBottom" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.top, style: { textAlign: "center" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.column2, style: { textAlign: "center", paddingTop: "20px" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Automated creation of",
	              _react2.default.createElement("br", null),
	              "YouTube video tours"
	            ),
	            _react2.default.createElement(
	              "div",
	              { width: "100%", style: { textAlign: "center", maxWidth: "400px", marginLeft: "auto", marginRight: "auto", paddingTop: "25px" } },
	              _react2.default.createElement(
	                "div",
	                { style: { textAlign: "center" }, className: classes.videoEmbed },
	                _react2.default.createElement("iframe", { className: classes.videoContainer, src: "https://www.youtube.com/embed/CwXlC7Xuojs",
	                  frameborder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowfullscreen: true })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column2, style: { textAlign: "center", paddingTop: "20px" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Lead Concierge nurtures your",
	              _react2.default.createElement("br", null),
	              "leads through to conversion"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center" } },
	              _react2.default.createElement("img", { src: _av2.default, width: "100%", style: { paddingTop: "25px", maxWidth: "320px" } })
	            )
	          ),
	          _react2.default.createElement("a", { id: "demo" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { backgroundColor: "#ffffff", paddingBottom: "60px", textAlign: "center", paddingRight: "30px", paddingLeft: "30px" } },
	      _react2.default.createElement(
	        "h1",
	        { className: classes.Heading2, style: { paddingTop: "70px" } },
	        "Get Elm Street Technology's Elevate CRM",
	        _react2.default.createElement("br", null),
	        "Today & the First Month is on Us!",
	        _react2.default.createElement(
	          "span",
	          { style: { fontSize: "19px" } },
	          _react2.default.createElement(
	            "sup",
	            null,
	            "*"
	          )
	        )
	      ),
	      _react2.default.createElement(_FormFreetrial2.default, {
	        subject: "Cyber Monday Free Trial Lead",
	        listid: "154467",
	        webhook: "5a0ac3e9-fa6f-11ec-a07e-bc764e046a9d",
	        leadsource: "tryelevate.com/cybermonday" })
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingTop: "50px", paddingBottom: "50px", backgroundColor: "#f7f7f7" } },
	      _react2.default.createElement(
	        "div",
	        { style: { textAlign: "center", paddingRight: "35px", paddingLeft: "35px", paddingBottom: "25px" } },
	        _react2.default.createElement(
	          "div",
	          { className: classes.Heading2 },
	          "Happy Customers"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.subtext },
	          "What the world needs now is love, love, love."
	        )
	      ),
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.flexContainer },
	          _react2.default.createElement(
	            "div",
	            { className: classes.flexItem2, style: { padding: "30px", textAlign: "center" } },
	            _react2.default.createElement("img", { src: _quote2.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext },
	              "\u201CI always struggled with creating & managing my social media until Elevate.  Now I look like a pro!\u201D",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: classes.Heading3 },
	                "Jennifer M."
	              ),
	              "San Clemente, CA"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.flexItem2, style: { padding: "30px", textAlign: "center" } },
	            _react2.default.createElement("img", { src: _quote2.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext },
	              "\u201CI\u2019ve had so many complements",
	              _react2.default.createElement("br", null),
	              "on my blog articles, and I don\u2019t have",
	              _react2.default.createElement("br", null),
	              "to lift a finger.\u201D",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: classes.Heading3 },
	                "Michael K."
	              ),
	              "Tampa, FL"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.flexItem2, style: { padding: "30px", textAlign: "center" } },
	            _react2.default.createElement("img", { src: _quote2.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext },
	              "\u201CElevate has saved me hours of frustration & time with my online marketing.  I love the automation.\u201D",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: classes.Heading3 },
	                "Mary Ann B."
	              ),
	              "Arlington, TX"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _flexContainer, _flexItem, _flexItem2, _flexItem3;
	
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      margin: "auto"
	    },
	
	    top: {
	      display: "flex",
	      flexWrap: "wrap",
	      alignItems: "top"
	    },
	
	    heading: {
	      fontSize: "33px",
	      fontWeight: "700",
	      lineHeight: "40px",
	      letterSpacing: ".14px",
	      color: "#52B1AD",
	      marginBottom: "12px"
	    },
	
	    subtext: {
	      fontSize: "16px",
	      fontWeight: "300",
	      lineHeight: "24px",
	      color: "#777777"
	    },
	
	    subtext2: {
	      fontSize: "16px",
	      fontWeight: "700",
	      lineHeight: "24px",
	      color: "#777777"
	    },
	
	    column2: {
	      width: "530px",
	      maxWidth: "100%",
	      paddingRight: "20px",
	      paddingLeft: "20px",
	      verticalAlign: "top"
	    },
	
	    column3: {
	      width: "350px",
	      maxWidth: "100%",
	      paddingRight: "10px",
	      paddingLeft: "10px",
	      verticalAlign: "top"
	    },
	
	    bold: {
	      fontWeight: "700"
	    },
	
	    centerHeading: {
	      alignItems: "center",
	      width: "100%",
	      textAlign: "center"
	    },
	
	    Heading2: {
	      fontSize: "28px",
	      paddingBottom: "20px",
	      fontWeight: "700",
	      lineHeight: "34px",
	      color: "#52B1AD",
	      letterSpacing: ".14px"
	    },
	
	    Heading3: {
	      fontSize: "20px",
	      paddingBottom: "5px",
	      fontWeight: "700",
	      lineHeight: "26px",
	      color: "#52B1AD",
	      letterSpacing: ".14px"
	    },
	
	    landingHeaderStyle: {
	      textAlign: "center"
	    },
	
	    buttonLink: {
	      minWidth: "250px",
	      maxWidth: "250px",
	      alignContent: "center",
	      justifyContent: "center",
	      fontSize: "14px",
	      fontWeight: "700",
	      display: "block",
	      letterSpacing: ".25px",
	      backgroundColor: "#52B1AD",
	      color: "#FFF",
	      textDecoration: "none",
	      padding: "16px",
	      borderRadius: "4px",
	      margin: "16px auto",
	      marginBottom: "10px"
	    },
	
	    flexContainer: (_flexContainer = {
	      padding: "0",
	      margin: '0',
	
	      display: "-webkit-box"
	    }, _flexContainer["display"] = "-moz-box", _flexContainer["display"] = "-ms-flexbox", _flexContainer["display"] = "-webkit-flex", _flexContainer["display"] = "flex", _flexContainer.flexWrap = "wrap", _flexContainer),
	    flexItem: (_flexItem = {
	      maxWidth: "100%",
	      width: "100%",
	      paddingRight: "0px",
	      paddingBottom: "25px"
	
	    }, _flexItem[theme.breakpoints[900]] = {
	      maxWidth: "50%",
	      width: "50%",
	      paddingRight: "20px",
	      paddingBottom: "0px"
	    }, _flexItem),
	
	    flexItem2: (_flexItem2 = {
	      maxWidth: "100%",
	      width: "100%",
	      paddingRight: "0px",
	      paddingBottom: "25px"
	
	    }, _flexItem2[theme.breakpoints[900]] = {
	      maxWidth: "33%",
	      width: "33%",
	      paddingRight: "20px",
	      paddingBottom: "0px"
	    }, _flexItem2),
	
	    flexItem3: (_flexItem3 = {
	      maxWidth: "100%",
	      width: "100%",
	      paddingRight: "0px",
	      paddingBottom: "25px"
	
	    }, _flexItem3[theme.breakpoints[900]] = {
	      maxWidth: "40%",
	      width: "40%",
	      paddingRight: "20px",
	      paddingBottom: "0px"
	    }, _flexItem3),
	    videoEmbed: {
	      position: "relative",
	      paddingBottom: "56.25%",
	      paddingTop: "30px",
	      height: "0",
	      overflow: "hidden"
	
	    },
	    videoContainer: {
	      position: "absolute",
	      top: "0",
	      left: "0",
	      width: "100%",
	      height: "100%"
	
	    }
	  };
	})(Freetrial);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-freetrial-js-5f69e6e401c736113c19.js